import { Column, Grid, Icon, LinkButton, Row, Text } from "@bunnix/components";
import { topics } from "./store/topics.mjs";
import Bunnix, { ForEach } from "@bunnix/core";
import "./app-header-more-menu.css";

const { div } = Bunnix;

export default function AppHeaderMoreMenu(props = {}) {
  const { topicClick = () => { } } = props;
  const gridColumns = [{ size: "auto" }, { size: "auto" }];

  return Column(
    LinkButton(
      {
        id: "app-heaer-more-button",
        class: "app-header-link",
        popovertarget: "app-more-topics-popover",
      },
      Row(Text("Tópicos"), Icon({ name: "chevron_down", size: 14 })),
    ),

    div(
      { id: "app-more-topics-popover", popover: "auto" },
      Grid(
        {
          layout: "fixed",
          columns: gridColumns,
          bgColor: "black",
          padding: "regular",
          gap: 24,
        },
        ForEach(topics, { key: "id" }, (t) =>
          LinkButton(
            {
              class: "app-header-link",
              popovertarget: "app-more-topics-popover",
              popovertargetaction: "hide",
              click: () => topicClick(t.id)
            },
            t.name,
          ),
        ),
      ),
    ),
  );
}
